module.exports = __webpack_public_path__ + "01_short_grey.dc4b6543.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_short_grey.png
// module id = 3hjm
// module chunks = 0